module.exports = __webpack_public_path__ + "img/briefcase.28af6655.svg";